var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "4",
          y: "4",
          width: "40",
          height: "40",
          rx: "20",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M10.9646 24.2043L18.5328 19.6746C21.7249 17.7633 25.6928 17.7006 28.9435 19.5109L38.3886 24.768L43.6556 27.6996C43.9688 26.0247 44.0738 24.275 43.9405 22.4829C43.1728 12.1688 34.4611 4.05688 24.121 4.00031C12.7122 3.93768 3.56611 13.3952 4.01866 24.8044C4.42879 35.1448 12.8576 43.582 23.1977 43.982C28.6546 44.1942 33.6267 42.2222 37.3441 38.8866L10.9646 24.2043Z",
          fill: "url(#paint0_linear_472_11214)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M30.6968 35.1849L22.9912 30.8955C19.7405 29.0873 17.702 25.6809 17.6434 21.9613L17.4737 11.1522L17.3787 5.12533C15.7705 5.69104 14.2048 6.47496 12.7198 7.48718C4.17177 13.308 1.50089 24.9091 6.62244 33.8938C12.2733 43.8059 25.0358 46.9981 34.6889 40.9006C43.437 35.3748 46.5301 23.8585 41.7076 14.702C39.162 9.87125 34.9677 6.54971 30.222 4.99805L30.6968 35.1849Z",
          fill: "url(#paint1_linear_472_11214)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          opacity: "0.4",
          d:
            "M30.3375 12.6052L30.4769 21.4243C30.5355 25.1439 28.606 28.6129 25.4139 30.5222L16.1385 36.0742L10.9665 39.1695C12.2615 40.2787 13.7222 41.2444 15.3405 42.0243C24.6563 46.5157 36.0368 43.0264 41.2574 34.0983C47.0153 24.2488 43.3989 11.5991 33.2932 6.28745C24.131 1.47485 12.611 4.55597 7.09351 13.3104C4.1822 17.929 3.40235 23.2224 4.43272 28.1098L30.3375 12.6052Z",
          fill: "url(#paint2_linear_472_11214)"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_472_11214",
                x1: "6.52349",
                y1: "14.273",
                x2: "40.5787",
                y2: "33.2273",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear_472_11214",
                x1: "21.8453",
                y1: "-13.2194",
                x2: "56.7602",
                y2: "6.21331",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear_472_11214",
                x1: "3.92131",
                y1: "12.8227",
                x2: "41.4701",
                y2: "33.7214",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#07A893" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.26", "stop-color": "#07A394" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.52", "stop-color": "#0A9797" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.8", "stop-color": "#0F829D" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#146EA3" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }